import { localNoCache } from "./axiousWithCache"

const state = {
  content: null
}

const mutations = {
  SET_CONTENT(state, content) {
    state.content = content
  }
}

const getters = {
  getHelpCenterContent(state) {
    return state.content
  }
}
const actions = {
  getHelpCenterContent(context, { contentKey, locale = "en" }) {
    const filePathMapping = {
      es: "/helpCenter/spanish/",
      en: "/helpCenter/"
    }

    const fallbackLocale = "en"

    const rootFilePath = filePathMapping[locale] || "/helpCenter/"

    const filePath = rootFilePath + contentKey + ".html"

    localNoCache
      .get(filePath)
      .then((res) => {
        if (res.data) {
          context.commit("SET_CONTENT", res.data)
        } else {
          // Fallback to English if localized content doesn't exist
          if (locale !== fallbackLocale) {
            context.dispatch("getHelpCenterContent", {
              contentKey,
              locale: fallbackLocale
            })
          } else {
            context.commit("SET_CONTENT", "No Information or this key")
          }
        }
      })
      .catch((err) => {
        context.commit("SET_CONTENT", err)
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
